import React from 'react';
import { Route, Switch } from 'react-router-dom';
import SurveyProcess from '../SurveyProcess';
import SurveyFinish from '../Finish';
import SurveyResult from '../Result';
import SurveyEdit from '../Edit';
import SurveyGreeting from '../SurveyGreeting';

export default () => {
	return (
		<Switch>
			<Route exact path="/survey" component={SurveyGreeting}/>
			<Route exact path="/survey/finish" component={SurveyFinish}/>
			<Route exact path="/survey/result" component={SurveyResult}/>
			<Route exact path="/survey/edit" component={SurveyEdit}/>
			<Route exact path="/survey/:status" component={SurveyProcess}/>
		</Switch>
	);
}



// WEBPACK FOOTER //
// ./src/components/Survey/Survey.js